var map = {
	"./BA-logo.png": "c58a",
	"./binance-logo.png": "953c",
	"./bitget_futures-logo.png": "e9e8",
	"./bitvavo-logo.png": "499d",
	"./bybit_futures-logo.png": "96ea",
	"./footer-logo.png": "55a4",
	"./ftx-logo.png": "3ade",
	"./kraken_futures-logo.png": "7c89",
	"./kucoin-logo.png": "13aa",
	"./okx_futures-logo.png": "9970",
	"./paypal-logo.png": "b489"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f992";